const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20woman%20in%20elegant%20dress%2C%20soft%20warm%20coral%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20webtoon%20cover%20style%2C%20clean%20simple%20composition%20with%20soft%20background&width=600&height=800&seq=cards-manga-01&orientation=portrait',
    tag: '新作上线',
    tagColor: 'bg-accent-500',
    title: '契约婚姻有点甜',
    author: '苏小暖',
    desc: '一纸契约将两个陌生人绑在一起，从互相嫌弃到暗生情愫，这场婚姻比想象中更甜蜜。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20action%20manga%20cover%20art%2C%20young%20warrior%20with%20sword%2C%20dynamic%20pose%2C%20warm%20orange%20and%20amber%20tones%2C%20shonen%20manga%20style%2C%20epic%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=cards-manga-02&orientation=portrait',
    tag: '人气连载',
    tagColor: 'bg-primary-500',
    title: '剑与魔法学院',
    author: '林小北',
    desc: '少年进入魔法学院，却发现自己的剑术天赋远在魔法之上，一场颠覆传统的冒险就此展开。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%2C%20ancient%20cultivator%20in%20flowing%20robes%2C%20mystical%20golden%20energy%2C%20warm%20amber%20and%20cream%20tones%2C%20xianxia%20style%2C%20elegant%20composition%20with%20traditional%20elements&width=600&height=800&seq=cards-manga-03&orientation=portrait',
    tag: '热门推荐',
    tagColor: 'bg-secondary-500',
    title: '九霄仙途',
    author: '墨染青衣',
    desc: '平凡少年偶得上古传承，从此踏上修仙之路，在九霄云外书写属于自己的传奇故事。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20mysterious%20mage%20character%2C%20magical%20effects%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20webtoon%20art%20style%2C%20clean%20composition%20with%20soft%20glowing%20background&width=600&height=800&seq=cards-manga-04&orientation=portrait',
    tag: '编辑力荐',
    tagColor: 'bg-accent-500',
    title: '异世界美食家',
    author: '七月的风',
    desc: '穿越到异世界的美食博主，用现代料理征服异世界味蕾，顺便收获了一群吃货伙伴。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romance%20manga%20cover%20art%2C%20high%20school%20couple%20under%20cherry%20blossoms%2C%20soft%20warm%20peach%20tones%2C%20shojo%20manga%20style%2C%20sweet%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=cards-manga-05&orientation=portrait',
    tag: '甜宠必看',
    tagColor: 'bg-primary-500',
    title: '樱花树下的约定',
    author: '浅夏初雨',
    desc: '高中毕业那天，樱花树下的一句玩笑话，竟成了两人十年后重逢的伏笔。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20manhua%20cover%2C%20modern%20young%20professional%2C%20city%20skyline%20background%2C%20warm%20amber%20and%20cream%20tones%2C%20slice%20of%20life%20style%2C%20clean%20composition%20with%20urban%20vibe&width=600&height=800&seq=cards-manga-06&orientation=portrait',
    tag: '口碑佳作',
    tagColor: 'bg-secondary-500',
    title: '程序员也想谈恋爱',
    author: '代码诗人',
    desc: '一个社恐程序员的恋爱攻略，从写代码到写情书，他的追爱之路笑料百出又温暖治愈。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            新作推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            本周必看新作
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            编辑团队精挑细选，推荐最值得入坑的新作与连载佳作
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold text-white ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-900 truncate font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.author}</p>
                <p className="text-xs text-foreground-600 mt-1.5 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}